// t = current time
// b = start value
// c = change in value
// d = duration
const easeInOutQuad = (t: number, b: number, c: number, d: number) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
};

if (process.env.WEBPACK) {
    if (!window.requestAnimationFrame) window.requestAnimationFrame = (window as any).webkitRequestAnimationFrame;
}


export function scrollTo(to: number, duration: number) {
    let start = window.scrollY,
        change = to - start,
        currentTime = 0,
        timeOffset: number;
    const animateScroll = (timestamp: number) => {
        if (!timeOffset) timeOffset = timestamp;
        currentTime = timestamp - timeOffset;
        let val = easeInOutQuad(currentTime, start, change, duration);
        window.scrollTo(0, val);
        if (currentTime < duration) {
            window.requestAnimationFrame(animateScroll);
        }
    };
    window.requestAnimationFrame(animateScroll);
}